import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import Layout from './components/Layout';
import Home from './components/Home';
import Dashboard from './components/Dashboard';
import ScrollToTop from './components/ScrollToTop';
import Arbitrage from './components/Arbitrage';
import ArbitrageCalculator from './components/ArbitrageCalculator';
import PositiveEV from './components/PositiveEV';
import PositiveEVCalculator from './components/PositiveEVCalculator';
import PromoConversion from './components/PromoConversion';
import PromoConversionCalculator from './components/PromoConversionCalculator';
import AboutUs from './components/AboutUs';
import HowItWorks from './components/HowItWorks';
import AccountSettings from './components/AccountSettings';
import SignUp from './components/SignUp';
import Login from './components/Login';
import ContactUs from './components/ContactUs';
import ReferFriend from './components/ReferFriend';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Disclaimer from './components/Disclaimer';
import Tools from './components/Tools';

// Wrapper that requires authentication
function ProtectedRoute({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut><RedirectToSignIn /></SignedOut>
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signup/*" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/login/*" element={<Login />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/refer" element={<ReferFriend />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/disclaimer" element={<Disclaimer />} />

          {/* Protected routes - require sign in */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/tools" element={<ProtectedRoute><Tools /></ProtectedRoute>} />
          <Route path="/arbitrage" element={<ProtectedRoute><Arbitrage /></ProtectedRoute>} />
          <Route path="/arbitrage-calculator" element={<ProtectedRoute><ArbitrageCalculator /></ProtectedRoute>} />
          <Route path="/positive-ev" element={<ProtectedRoute><PositiveEV /></ProtectedRoute>} />
          <Route path="/positive-ev-calculator" element={<ProtectedRoute><PositiveEVCalculator /></ProtectedRoute>} />
          <Route path="/promo-conversion" element={<ProtectedRoute><PromoConversion /></ProtectedRoute>} />
          <Route path="/promo-conversion-calculator" element={<ProtectedRoute><PromoConversionCalculator /></ProtectedRoute>} />
          <Route path="/account" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />
          <Route path="/account/:section" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
